import { css } from 'styled-components';

export const styles = {
  flexCenter: css`
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  fullContainerSize: css`
    width: 100%;
    height: 100%;
  `,
  absoluteCenter: css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  `,
  absoluteCenterVertical: css`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  `,
  absoluteCenterHorizontal: css`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  `,
};
